import React from "react";
import { Avatar, Card, CardBody, CircularProgress } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BsArrowUpRightCircleFill } from "react-icons/bs";

const descriptionToFilterMap = {
  "Green Calls": "green",
  "Red Calls": "red",
  "Orange Calls": "orange",
  "Answering Machine": "answerphone",
  "Frustrated Clients": "frustrated",
};

const OverviewCard = ({
  overview,
  loading = false,
  hasRedirections = false,
  isRepresentativePopup = false,
  beforeRedirect = () => {},
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isGlobalWidget = overview.description === "Number of Calls";
  const hasFilterTarget = descriptionToFilterMap[overview.description] !== undefined;
  const hasRedirection =
    hasRedirections && (isRepresentativePopup || (!isGlobalWidget && hasFilterTarget));

  const onWidgetClick = () => {
    if (!hasRedirection) {
      return;
    }

    if (beforeRedirect) {
      beforeRedirect();
    }

    if (isGlobalWidget) {
      navigate("/calls");
      return;
    }

    const filterName = descriptionToFilterMap[overview.description];

    if (!filterName) {
      return;
    }

    navigate(`/calls?filter=${filterName}`);
  };

  return (
    <Card
      className={`relative w-full px-[16px] py-[12px] h-full rounded-md !shadow-custom-light ${
        hasRedirection ? " cursor-pointer" : ""
      }`}
      classNames={{
        body: "p-0 h-full",
      }}
      shadow="none"
    >
      {/* {hasRedirection && (
        <BsArrowUpRightCircleFill
          className="absolute top-[8px] right-[8px] text-[#EAE6FF]"
          size={22}
        />
      )} */}
      <CardBody>
        <div
          onClick={onWidgetClick}
          onKeyDown={onWidgetClick}
          className="h-full flex items-center space-x-2 font-PlusJakartaSans p-0"
        >
          <div className="flex items-center">
            <Avatar
              isBordered
              radius="full"
              size="xl"
              icon={
                <overview.icon
                  className={`text-sm ${overview.text_color}`}
                  size={18}
                />
              }
              className={`${overview.bg_color} ring-0 ring-offset-0`}
            />
          </div>
          <div className="flex flex-col space-y-0 items-start justify-center pl-2">
            <h5 className="text-sm text-[#737373]">
              {t(overview.description)}
              {overview?.subtitle && (
                <small className="text-tiny">&nbsp;/{overview?.subtitle}</small>
              )}
            </h5>
            <div className="flex items-center space-x-4">
              {!loading ? (
                <h4 className={`text-[24px] font-semibold ${overview.kpi_text_color}`}>
                  {(overview?.count || 0).toLocaleString("fr-FR")}{" "}
                  {overview?.currency_sign && overview?.currency_sign}
                </h4>
              ) : (
                <CircularProgress
                  aria-label="Loading..."
                  color="primary"
                />
              )}
              {/* <div className="flex flex-col items-start">
                <div className="flex items-end w-full text-success">
                  <span className=" text-[12px] leading-3 font-medium">+2.45</span>
                  <IoMdArrowDropup className="w-4 h-4" />
                </div>
                <span className="text-[12px] text-default-300">/ {t("last month")}</span>
              </div> */}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default OverviewCard;
